import { FC } from "react";

import { ThemedFundraiser, ThemedFundraiserProps } from "@/features/FormV2/sharedComponents/ThemedFundraiser";
import { useTranslate } from "@/hooks/useTranslate";

export type ThemedIndividualFundraiserProps = Omit<ThemedFundraiserProps, "title" | "subtitle"> & {
  campaignTitle: string;
  totalRaised?: number;
  isPartOfTeam?: boolean;
};

export const ThemedIndividualFundraiser: FC<ThemedIndividualFundraiserProps> = ({
  href,
  imageSrc,
  campaignTitle,
  totalRaised,
  currency,
  isPartOfTeam = false,
  ...rest
}) => {
  const { t } = useTranslate();

  return (
    <ThemedFundraiser
      {...rest}
      href={href}
      imageSrc={imageSrc}
      title={t("donationForm", "peerToPeer.individualFundraiser.title", { title: campaignTitle })}
      subtitle={
        isPartOfTeam
          ? t("donationForm", "peerToPeer.individualCampaignType.teamMember")
          : t("donationForm", "peerToPeer.individualCampaignType.individual")
      }
      totalRaised={totalRaised}
      currency={currency}
      showFallbackImage
    />
  );
};
